<template>
  <div class="content-tab rstp">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <div class="content-item">
        <div class="describe">
          {{$t('rstp.describe')}}
        </div>
        <div class="formRow">
          <span class="title">{{$t('rstp.title')}}</span>
          <toggle :on="getToggle(rstpObj.config)" @click.native="onSwitchBtn()"></toggle>
        </div>
        <div class="formRow">
          <div class="title">{{$t('rstp.priority')}}</div>
          <div class="forminput">
            <q-select class="priority-select" :class="{'disabled': (originalData && originalData.config.val === 2)}" :options-array="menuOptions" :value="rstpObj.priority | getVal" :isWhite="false" @change="onMenuChange" :isDisabled="(originalData && originalData.config.val === 2)"></q-select>
          </div>
        </div>
        <div class="formRow group-table">
          <fixed-table ref="portTable" :data="rstpObj.port" :use-page="false" :header-height="40">
            <div class="right-header" slot="right-header">
              <column style="width:17%;">{{$t('port.portnumber')}}</column>
              <column style="width:13.5%;">{{$t('action')}}</column>
              <column style="width:22.5%;">{{$t('rstp.role')}}</column>
              <column style="width:47%;">{{$t('rstp.state')}}</column>
            </div>
            <template slot="rows" slot-scope="props">
              <div class="link-row">
                <row class="right" :props="props" :title="getTooltips(props.data.key)">
                  <div class="data" style="width:17%;">{{getPortName(props.data.key)}}</div>
                  <div class="data" style="width:13.5%;">
                    <toggle :on="getToggle(props.data)" @click.native="onSwitchBtn(props)" :disabled="getDisabled(props.data.key)"></toggle>
                  </div>
                  <div class="data" style="width:22.5%;">{{getRole(props.data)}}</div>
                  <div class="data" style="width:47%;">{{getState(props.data)}}</div>
                </row>
              </div>
            </template>
          </fixed-table>
        </div>
      </div>
      <div class="content-body-footer">
        <button class="q-button blue-btn-full right" :title="$t('save')" @click="onSaveClick()" :disabled="!isButtonEnable">{{$t('save')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import toggle from './module/Toggle'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import qSelect from './module/Select.vue'
export default {
  name: 'rstp',
  components: {
    toggle,
    fixedTable,
    row,
    column,
    qSelect
  },
  data () {
    return {
      dataInterval: null,
      isShowLoading: false,
      isButtonEnable: false,
      rstpObj: {},
      originalData: null,
      menuOptions: [],
      selectPriority: 0
    }
  },
  beforeDestroy () {
    clearInterval(this.dataInterval)
    this.dataInterval = null
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  watch: {
    isButtonEnable: function (value) {
      if (!value) {
        this.$store.commit('updateDataChanged', false)
      } else {
        this.$store.commit('updateDataChanged', true)
      }
    },
    currentUser: {
      handler (value) {
        if (!value) {
          this.$store.commit('updateGetDeviceData', false)
          clearInterval(this.dataInterval)
          this.dataInterval = null
          this.onClose()
        }
      },
      immediate: true,
      deep: true
    },
    showFullLoading: function (value) {
      if (value) {
        clearInterval(this.dataInterval)
        this.dataInterval = null
      }
    }
  },
  filters: {
    getVal (value) {
      if (value) {
        return value.val
      }
    }
  },
  created: async function () {
    this.menuOptions = []
    for (let idx = 0; idx < 16; idx++) {
      this.menuOptions.push({
        value: 4096 * idx, label: '' + (4096 * idx)
      })
    }
    this.getData()
  },
  methods: {
    ...mapActions(['getRSTPconfig', 'setRSTPconfig', 'getRSTPinterface', 'setRSTPinterface', 'getRSTPpriority', 'setRSTPpriority', 'getRSTProle', 'getRSTPstate']),
    getToggle: function (data) {
      if (data && data.val === 1) {
        return true
      } else {
        return false
      }
    },
    getRole: function (data) {
      let result = '--'
      if (data.val === 1) {
        switch (data.role) {
          case 0:
            result = this.$t('rstp.disabled')
            break
          case 1:
            result = this.$t('rstp.alternate')
            break
          case 2:
            result = this.$t('rstp.backup')
            break
          case 3:
            result = this.$t('rstp.root')
            break
          case 4:
            result = this.$t('rstp.designated')
            break
          default:
            break
        }
      }
      return result
    },
    getState: function (data) {
      let result = '--'
      if (data.val === 1) {
        switch (data.state) {
          case 0:
            result = this.$t('rstp.discard')
            break
          case 1:
            result = this.$t('rstp.learn')
            break
          case 2:
            result = this.$t('rstp.forward')
            break
          default:
            break
        }
      }
      return result
    },
    getDataInterval: function () {
      let me = this
      this.dataInterval = setInterval(() => {
        if (me.showFullLoading) {
          clearInterval(me.dataInterval)
          me.dataInterval = null
        } else {
          this.axios.all([this.getRSTProle(), this.getRSTPstate()])
            .then(this.axios.spread(function (role, state) {
              me.rstpObj['port'].forEach((element, idx) => {
                if (role.result) {
                  role.result.forEach((roleItem) => {
                    if (roleItem.key === element.key) {
                      me.rstpObj.port[idx]['role'] = roleItem.val
                    }
                  })
                }
                if (state.result) {
                  state.result.forEach(stateItem => {
                    if (stateItem.key === element.key) {
                      me.rstpObj.port[idx]['state'] = stateItem.val
                    }
                  })
                }
              })
            }))
        }
      }, this.intervalTime)
    },
    getData: function () {
      let me = this
      this.isShowLoading = true
      clearInterval(this.dataInterval)
      this.dataInterval = null
      if (!this.deviceCollapsed) this.$store.commit('updateGetDeviceData', true)
      this.axios.all([this.getRSTPconfig(), this.getRSTPpriority(), this.getRSTPinterface(), this.getRSTProle(), this.getRSTPstate()])
        .then(this.axios.spread(function (config, priority, port, role, state) {
          let tempObj = {}
          if (priority.error_code === 200) {
            tempObj['priority'] = priority.result[0]
          }
          if (config.error_code === 200) {
            tempObj['config'] = {key: config.result[0].key, val: config.result[0].val}
            if (config.result[0].val === 1) {
              if (port.error_code === 200 && port.result) {
                tempObj['port'] = []
                // let portNumber = null
                port.result.forEach((element, idx) => {
                  if (Number(element.key) <= me.lagStartNum + me.lagGroupMap.size) {
                    tempObj['port'].push({
                      key: element.key,
                      val: element.val,
                      role: 0,
                      state: 0
                    })
                    role.result.forEach((roleItem) => {
                      if (roleItem.key === element.key) {
                        tempObj.port[idx]['role'] = roleItem.val
                      }
                    })
                    state.result.forEach(stateItem => {
                      if (stateItem.key === element.key) {
                        tempObj.port[idx]['state'] = stateItem.val
                      }
                    })
                  }
                })
                // tempObj['port'] = port.result
                // tempObj['port'].forEach((element, idx) => {
                //   role.result.forEach((roleItem) => {
                //     if (roleItem.key === element.key) {
                //       tempObj.port[idx]['role'] = roleItem.val
                //     }
                //   })
                //   state.result.forEach(stateItem => {
                //     if (stateItem.key === element.key) {
                //       tempObj.port[idx]['state'] = stateItem.val
                //     }
                //   })
                // })
              }
            } else {
              tempObj['port'] = []
              for (let idx = 1; idx <= me.portNumber + me.lagGroupMap.size; idx++) {
                tempObj['port'].push({
                  key: (idx < me.portNumber + 1) ? idx : idx + (me.lagStartNum - me.portNumber),
                  val: 2,
                  role: -1,
                  state: -1
                })
              }
            }
          }
          me.rstpObj = tempObj
          me.isShowLoading = false
          if (me.rstpObj.config.val === 1) {
            me.setDisabledData()
            me.getDataInterval()
          } else {
            me.originalData = JSON.parse(JSON.stringify(me.rstpObj))
          }
          me.checkBtnValidate()
        }))
    },
    setDisabledData: function () {
      if (this.portMap.size > 0) {
        this.portMap.forEach((val, key) => {
          this.rstpObj.port.splice(key - 1, 0, {
            key: key,
            val: 2,
            role: -1,
            state: -1
          })
        })
      }
      this.rstpObj.port.sort(function (a, b) {
        return Number(a.key) - Number(b.key)
      })
      this.originalData = JSON.parse(JSON.stringify(this.rstpObj))
    },
    setInitData: function () {
      let temp = []
      if (this.rstpObj.config.val === 1 && this.rstpObj.config.val !== this.originalData.config.val) {
      } else if (this.rstpObj.config.val === 2 && this.rstpObj.config.val === this.originalData.config.val) {
        this.rstpObj['priority'].val = 0
        for (let idx = 0; idx < this.portNumber; idx++) {
          temp.push({
            key: idx + 1,
            val: 2,
            role: -1,
            state: -1
          })
        }
        this.rstpObj['port'] = temp
      }
    },
    getPortName: function (key) {
      if (key < this.portNumber + 1) {
        return key
      } else {
        let name = key - Number(this.lagStartNum)
        return this.$t('lag.groupName') + ' ' + name
      }
    },
    checkBtnValidate: function () {
      let result = this.$compareObj(this.originalData, this.rstpObj)
      this.isButtonEnable = !result
    },
    onSwitchBtn: function (data) {
      if (data) {
        if (this.rstpObj.config.val !== 2) {
          this.rstpObj.port[data.index].val = (this.rstpObj.port[data.index].val === 1) ? 2 : 1
        }
      } else {
        this.rstpObj.config.val = (this.rstpObj.config.val === 1) ? 2 : 1
      }
      this.checkBtnValidate()
    },
    onMenuChange (value) {
      this.rstpObj.priority.val = value
      this.checkBtnValidate()
    },
    onSaveClick: function () {
      let me = this
      let checkData = {
        rstpConf: false,
        rstpPort: false,
        rstpPrio: false
      }
      // this.isShowLoading = true
      clearInterval(this.dataInterval)
      this.dataInterval = null
      this.$store.commit('updateGetDeviceData', false)
      this.$store.commit('updateFullLoadingStatus', true)
      function checkConnect () {
        me.getRSTPconfig()
          .then((result) => {
            setTimeout(() => {
              me.$store.commit('updateReloadDeviceStatus', true)
              me.$store.commit('updateFullLoadingStatus', false)
              me.getData()
            }, 10000)
          }).catch((err) => {
            if (err.message.includes('timeout')) {
              checkConnect()
            } else {
              me.$store.commit('updateFullLoadingStatus', false)
            }
          })
      }
      function checkSetDone () {
        if (checkData.rstpPrio && checkData.rstpPort) {
          setTimeout(() => {
            me.$store.commit('updateReloadDeviceStatus', true)
            me.$store.commit('updateFullLoadingStatus', false)
            me.getData()
          }, 10000)
        }
      }
      function goSavePriorityNport () {
        let count = 0
        let checkCount = 0
        let setArr = []
        if (!me.$compareObj(me.rstpObj.port, me.originalData.port)) {
          me.rstpObj.port.forEach((element, index) => {
            if (element.val !== me.originalData.port[index].val) {
              count++
              if (!me.portMap.get(element.key)) {
                setArr.push({'idx': element.key, 'data': element.val})
                checkCount++
              }
            }
          })
          if (setArr.length > 0) {
            me.setRSTPinterface(setArr).then((res) => {
              if (count === checkCount) {
                checkData.rstpPort = true
                checkSetDone()
              }
            })
          }
        } else {
          checkData.rstpPort = true
          checkSetDone()
        }
        if (me.rstpObj.priority.val !== me.originalData.priority.val) {
          me.setRSTPpriority(me.rstpObj.priority)
            .then((res) => {
              checkData.rstpPrio = true
              checkSetDone()
            })
        } else {
          checkData.rstpPrio = true
          checkSetDone()
        }
      }
      if (this.rstpObj.config.val !== this.originalData.config.val) {
        this.setRSTPconfig(this.rstpObj.config)
          .then((result) => {
            setTimeout(() => {
              me.$store.commit('updateReloadDeviceStatus', true)
              me.$store.commit('updateFullLoadingStatus', false)
              this.getData()
            }, 10000)
          }).catch((err) => {
            if (err.message.includes('timeout')) {
              checkConnect()
            } else {
              me.$store.commit('updateFullLoadingStatus', false)
            }
          })
      } else if (this.originalData.config.val === 1) {
        goSavePriorityNport()
      }
    },
    getDisabled: function (key) {
      if (this.originalData.config.val === 2 || this.rstpObj.config.val === 2 || this.portMap.get(key)) {
        return true
      } else {
        return false
      }
    },
    getTooltips: function (key) {
      if (this.portMap.get(key)) {
        return this.$t('lag.alreadyJoin')
      } else {
        return ''
      }
    }
  },
  computed: {
    ...mapState({
      sysBoard: state => state.module.sysBoard,
      portNumber: state => state.module.portNum,
      currentUser: state => state.module.currentUser,
      isDataChanged: state => state.app.isDataChanged,
      lagGroupMap: state => state.module.lagGroupMap,
      portMap: state => state.module.portMap,
      lagStartNum: state => state.module.lagStartNum,
      showFullLoading: state => state.module.showFullLoading,
      deviceCollapsed: state => state.app.deviceCollapsed,
      intervalTime: state => state.app.intervalTime
    })
  }
}
</script>

<style lang="scss" scoped>
.rstp {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .content-body {
    padding: 10px;
    .content-item {
      height: calc(100% - 40px);
    }
    .title, .forminput {
      display: inline-block;
    }
    .q-select {
      width: 100px;
      /deep/ .dropdown-menu {
        width: 100px;
      }
    }
    .formRow {
      margin-top: 10px;
    }
    .group-table {
      height: calc(100% - 120px);
      min-width: 600px;
      .title {
        height: 100%;
        padding-left: 20px;
        position: relative;
        line-height: 40px;
        font-family: 'Roboto-M' !important;
        .subtitle {
          position: absolute;
          display: inline-block;
          right: 10px;
          top: 0px;
        }
        .slash {
          position: absolute;
          display: inline-block;
          width: 100%;
          height: 40px;
          top: 0;
          left: 0;
          &:before {
            content: attr(data-text);
            position:absolute;
            left:0px;
            top:0;
            right:0;
            bottom:0;
            -webkit-clip-path: polygon(0 0, 0 100%, 230% 225%, 0 0);
            clip-path: polygon(0 0, 0 100%, 230% 225%, 0 0);
            background:#fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Rstp.vue